export enum EntityType {
  INSTANCE = 'INSTANCE',
  BLUEPRINT = 'BLUEPRINT',
  SERVICE = 'SERVICE',
}
